import PropTypes from 'prop-types'
import React from 'react'

const BooleanPill = ({ boolean }) => {
  const pillColor = boolean ? 'pill--green' : 'pill--red'
  const pillText = boolean ? 'True' : 'False'

  return (
    <span className={`pill ${pillColor}`}>
      {pillText}
    </span>
  )
}

BooleanPill.propTypes = {
  boolean: PropTypes.bool.isRequired
}

export default BooleanPill
